export const CHANGED = "CHANGED"

export const setChanged = (data:any) => {
    return {
        type:CHANGED,
        payload:data
    }
}